import React from 'react';
import { AccordianList } from '../../../../common/AccordianList';
import { closeModalAction, openCustomModal, openTextModalAction } from '../../../../actions/modal';
import { useDispatch } from 'react-redux';
import AddTeamsInConversation from '../../Modals/AddTeamsInConversation';
import MaterialIconToolTip from '../../../../common/MaterialIconToolTip';
import OverflowTip from '../../../../common/OverflowTip';
import { removeTeamsFromChat } from '../../../../actions/chat';

function GroupTeam({ teams, conversationId, isLoggedUserIsAdmin, org_id }) {
    const dispatch = useDispatch();

    const onAddTeamClick = () => {
        let heading = 'Add Team';
        let modalWidth = '55rem';
        let modalHeight = 'auto';
        let modalComponent = (
            <AddTeamsInConversation existingTeamIds={teams.map((team) => team.id)} conversationId={conversationId} org_id={org_id} />
        );
        dispatch(openCustomModal({ heading, modalWidth, modalHeight, modalComponent }));
    };

    return (
        <>
            <div className='p-6 border-t-10 bg-white rounded-lg shadow-sm'>
                <div className="flex items-center justify-between mb-5">
                    <h3 className="text-lg font-semibold text-scogoprimary flex items-center">
                        <span className="material-icons mr-2 text-scogoprimary text-font16">label</span>
                        Teams <span className="ml-1 text-sm font-medium text-gray-500">{(teams.length)}</span>
                    </h3>

                    {isLoggedUserIsAdmin && (
                        <button
                            onClick={() => onAddTeamClick()}
                            className="flex items-center text-xs font-medium text-scogoprimary hover:text-scogoorange transition-colors duration-200 px-3 py-1 rounded-full border border-gray-200 hover:border-scogoorange"
                        >
                            <span className="material-icons text-font14 mr-1">person_add</span>
                            Add Teams
                        </button>
                    )}
                </div>

                {teams.length > 0 ? (
                    <div className='mt-4 space-y-3'>
                        <AccordianList
                            itemKey='id'
                            list={teams}
                            ItemComponent={GroupTeamInfo}
                            numberOfItemToShow={3}
                            itemProps={{ isLoggedUserIsAdmin, conversationId }}
                            showMoreTitle='Show All Teams'
                        />
                    </div>
                ) : (
                    <div className="py-4 text-center text-gray-500">
                        <p>No teams tagged yet</p>
                    </div>
                )}
            </div>
        </>
    );
}

export default GroupTeam;

const formName = 'remove_team';
function GroupTeamInfo({ item: team, isLoggedUserIsAdmin, conversationId }) {
    const dispatch = useDispatch();

    const removeTeam = () => {
        dispatch(removeTeamsFromChat({ id: conversationId, teamIds: [team.id], formName }));
    };

    const onRemoveTeamClick = () => {
        let heading = 'Remove Team';
        let text = `Do you want to remove ${team?.name ? team.name : 'team'}?`;
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: removeTeam,
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                buttonClass: 'hover:bg-scogobgsky',
                onClick: () => dispatch(closeModalAction()),
            },
        ];

        let closeOnBackdropClick = false;
        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName }));
    };

    return (
        <div className='flex w-full items-center p-2.5 rounded-md hover:bg-gray-50 transition-colors duration-150 group' key={team.id}>
            <div className='flex items-center flex-1 min-w-0'>
                <div className='truncate'>
                    <p className='text-font10 font-medium text-gray-800 truncate'>
                        <OverflowTip someLongText={team.name} />
                    </p>
                </div>
            </div>
            {isLoggedUserIsAdmin && (
                <div className='ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-200'>
                    <MaterialIconToolTip
                        onClick={() => onRemoveTeamClick()}
                        title='Remove Team'
                        materialIconName='close'
                        materialIconClass='hover:text-scogoorange cursor-pointer material-icons text-gray-500 hover:bg-gray-100 p-1 rounded-full text-font18'
                    />
                </div>
            )}
        </div>
    );
}
